import { Module03, Module03Props } from 'components/gruenland/organisms/mod03_3Immagini/Module03';
import { TasticProps } from '../../types';

const Immagini3Tastic = ({ data }: TasticProps<Module03Props>) => {
  return <Module03 {...data} />;
};

export default Immagini3Tastic;
